import { memo } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const AgeRulesDialog = memo(({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Age-Based Rules (All Financers)</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              p: 2,
              backgroundColor: "#f0fdf4",
              borderRadius: 1,
              border: "1px solid #86efac",
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#059669", fontWeight: 600, mb: 1 }}
            >
              ✓ Normal Age Range:
            </Typography>
            <Typography variant="body2" sx={{ color: "#059669" }}>
              Minimum Age: 18 years
            </Typography>
            <Typography variant="body2" sx={{ color: "#059669" }}>
              Maximum Age: 55 years
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              backgroundColor: "#fef3c7",
              borderRadius: 1,
              border: "1px solid #fcd34d",
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#b45309", fontWeight: 600, mb: 1 }}
            >
              ⚠ Age Exception (Below 18 or Above 55):
            </Typography>
            <Typography variant="body2" sx={{ color: "#b45309", mb: 1 }}>
              • Prior approval required from Shashank/Vishwa/Ravi Sir
            </Typography>
            <Typography variant="body2" sx={{ color: "#b45309", mb: 1 }}>
              • If approved → Guarantor mandatory
            </Typography>
            <Typography variant="body2" sx={{ color: "#b45309", mb: 1 }}>
              • Guarantor must submit: Affidavit, Signed Cheques, Aadhaar,
              Complete KYC
            </Typography>
            <Typography variant="body2" sx={{ color: "#b45309" }}>
              • Co-Applicant not allowed in age exceptions
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});

AgeRulesDialog.displayName = "AgeRulesDialog";

export default AgeRulesDialog;
